<div class="wrapper">
    <div class="cargando-jardin">
        <mat-spinner *ngIf="cargando"></mat-spinner>
    </div>
    <div *ngIf="!cargando" class="contenidoBase">

        <input type="checkbox" id="nav-toggle">
        <div class="sidebar">
            <div class="sidebar-brand profile">
                <div class="junji-profile">
                    <img src="../../../assets/icons/JUNJI__JUNJI-logo.svg">
                </div>
                <ng-template #popContent>
                    <button (click)="cambiarPass()" type="button" class="btn btn-light btn-popover"><i class="fas fa-key"></i> CAMBIAR CLAVE</button>
                    <button (click)="cambiarFoto()" type="button" class="btn btn-light btn-popover"><i class="fas fa-portrait"></i> CAMBIAR FOTO</button>
                    <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-popover"><i class="fas fa-power-off"></i> SALIR</button>
                </ng-template>
                <ng-template #popTitle>{{datosDirec.nombreDirectora}} <br> {{datosDirec.correo}}</ng-template>
                <button class="image-cropper" placement="bottom" [ngbPopover]="popContent" [popoverTitle]="popTitle">
                        <img [src]="urlProfile" alt="avatar" id="improfile" class="profile-pic" >  
                </button>
                <p class="welcomeText">Bienvenida,</p>
                <p class="userName">{{datosDirec.nombreDirectora}}</p>
            </div>
            <!--Secciones-del-tablero-->
            <div class="sidebar-menu">
                <ul>

                    <li>
                        <a (click)="menuVisible('inicio')" [className]="menuMostrar==='inicio'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_inicio_off.svg" *ngIf="menuMostrar!='inicio'">
                            <img src="../../../assets/icons/JUNJI_inicio_on.svg" *ngIf="menuMostrar==='inicio'">
                            <span class="menu-text">INICIO</span>
                        </a>
                    </li>
                
                    <li>
                        <a (click)="menuVisible('identity')" [className]="menuMostrar==='identity'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_identificacion_off.svg" *ngIf="menuMostrar!='identity'">
                            <img src="../../../assets/icons/JUNJI_identificacion_on.svg" *ngIf="menuMostrar==='identity'">
                            <span class="menu-text">IDENTIFICACIÓN</span>
                        </a>
                    </li>
                   
                    <!-- <li>
                        <a (click)="menuVisible('planmejora')" [className]="menuMostrar==='planmejora'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_plan-mejora_off.svg" *ngIf="menuMostrar!='planmejora'">
                            <img src="../../../assets/icons/JUNJI_plan-mejora_on.svg" *ngIf="menuMostrar==='planmejora'">
                            <span class="menu-text">PLAN DE MEJORA ANTIGUO</span>
                        </a>
                    </li> -->
                    <div>
                        <li>
                            <a (click)="menuVisible('new-planmejora')" [className]="menuMostrar==='new-planmejora'? 'active' : ''">
                                <img src="../../../assets/icons/JUNJI_plan-mejora_off.svg" *ngIf="menuMostrar!='new-planmejora'">
                                <img src="../../../assets/icons/JUNJI_plan-mejora_on.svg" *ngIf="menuMostrar==='new-planmejora'">
                                <span class="menu-text">PLAN DE MEJORAMIENTO EDUCATIVO</span>
                            </a>
                        </li>
                    </div>
                    <li>
                        <a (click)="menuVisible('gestion-convivencia')" [className]="menuMostrar==='gestion-convivencia'? 'active' : ''">
                            <img src="../../../assets/icons/plan_gestion_Off.svg" *ngIf="menuMostrar!='gestion-convivencia'">
                            <img src="../../../assets/icons/plan_gestion_On.svg" *ngIf="menuMostrar==='gestion-convivencia'">
                            <span class="menu-text">PLAN DE GESTIÓN DE LA CONVIVENCIA</span>
                        </a>
                    </li>

                    <!--li>
                        <a (click)="menuVisible('instrumento-autoevaluacion')" [className]="menuMostrar==='instrumento-autoevaluacion'? 'active' : ''">
                            <img src="../../../assets/icons/autoevaluacion__Off.svg" *ngIf="menuMostrar!='instrumento-autoevaluacion'">
                            <img src="../../../assets/icons/autoevaluacion__On.svg" *ngIf="menuMostrar==='instrumento-autoevaluacion'">
                            <span class="menu-text">INSTRUMENTO DE AUTOEVALUACIÓN</span>
                        </a>
                    </li-->

                    <li>
                        <a (click)="menuVisible('proyecto-educativo')" [className]="menuMostrar==='proyecto-educativo'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_proyecto-edu_off.svg" *ngIf="menuMostrar!='proyecto-educativo'">
                            <img src="../../../assets/icons/JUNJI_proyecto-edu_on.svg" *ngIf="menuMostrar==='proyecto-educativo'">
                            <span class="menu-text">PROYECTO EDUCATIVO INSTITUCIONAL</span>
                        </a>
                    </li> 

                    <li>
                        <a (click)="menuVisible('resultados-seicep')" [className]="menuMostrar==='resultados-seicep'? 'active' : ''">
                            <img src="../../../assets/icons/seicep-off.svg" *ngIf="menuMostrar!='resultados-seicep'">
                            <img src="../../../assets/icons/seicep-on.svg" *ngIf="menuMostrar==='resultados-seicep'">
                            <span class="menu-text">RESULTADO SEICEP</span>
                        </a>
                    </li>
   
                    <li>
                        <a (click)="menuVisible('medicion-satisfaccion')" [className]="menuMostrar==='medicion-satisfaccion'? 'active' : ''">
                            <img src="../../../assets/icons/seicep-off.svg" *ngIf="menuMostrar!='medicion-satisfaccion'">
                            <img src="../../../assets/icons/seicep-on.svg" *ngIf="menuMostrar==='medicion-satisfaccion'">
                            <span class="menu-text">MEDICIÓN SATISFACCIÓN</span>
                        </a>
                    </li>
                    <li>
                        <a href="https://sismat.junji.gob.cl/" target="_blank">
                            <img src="../../../assets/icons/seicep-off.svg">
                            <span class="menu-text">SISTEMA DE MATERIALES SISMAT</span>
                        </a>
                    </li>
                    <li>
                        <a href="https://gea.junji.gob.cl/" target="_blank">
                            <img src="../../../assets/icons/autoevaluacion__Off.svg">
                            <span class="menu-text">SISTEMA GEA</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('reglamento-interno')" [className]="menuMostrar==='reglamento-interno'? 'active' : ''">
                            <img src="../../../assets/icons/reglamento_Off.svg" *ngIf="menuMostrar!='reglamento-interno'">
                            <img src="../../../assets/icons/reglamento_On.svg" *ngIf="menuMostrar==='reglamento-interno'">
                            <span class="menu-text">REGLAMENTO INTERNO</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('biblioteca')" [className]="menuMostrar==='biblioteca'? 'active' : ''">
                            <img src="../../../assets/icons/biblioteca_Off.svg" *ngIf="menuMostrar!='biblioteca'">
                            <img src="../../../assets/icons/biblioteca_On.svg" *ngIf="menuMostrar==='biblioteca'">
                            <span class="menu-text">BIBLIOTECA</span>
                        </a>
                    </li>
                    <li>
                        <a href="mailto:escritoriodigital@junji.cl" target="_blank">
                            <img src="../../../assets/ico__mensajeria.svg">
                            <span class="menu-text"><![CDATA[escritoriodigital@junji.cl]]></span>
                        </a>
                    </li>
                  
                </ul>
            </div>

            <div class="sidebar-brand">
                <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-logout"><i class="fas fa-power-off"></i> Salir</button>
            </div>
        </div>


        <div class="main-content">
            <header>
                <div>
                    <p class="title1">
                        ESCRITORIO DIGITAL
                    </p>
                    <p class="title2">
                        del Jardín Infantil
                    </p>
                </div>

                <div class="user-wrapper">
                    <div>

                        <p class="title-jardin">JARDÍN INFANTIL:</p>
                        <div class="jardin-name">
                            <p> {{jardin.jardin}}</p>
                        </div>


                    </div>
                </div>
            </header>

            <main>
                <app-inicio-jardin [simulacion]="simulacion" *ngIf="menuMostrar==='inicio'"></app-inicio-jardin>
                <app-identificacion [simulacion]="simulacion" *ngIf="menuMostrar==='identity'"></app-identificacion>
                <app-proyecto-educativo [simulacion]="simulacion" *ngIf="menuMostrar==='proyecto-educativo'"></app-proyecto-educativo>
                <app-jardin-plan-mejora *ngIf="menuMostrar==='planmejora'"></app-jardin-plan-mejora>
                <app-plan-gestion-convivencia [simulacion]="simulacion" *ngIf="menuMostrar==='gestion-convivencia'"></app-plan-gestion-convivencia>
                <app-reglamento-interno [simulacion]="simulacion" *ngIf="menuMostrar==='reglamento-interno'"></app-reglamento-interno>
                <app-historial [simulacion]="simulacion" *ngIf="menuMostrar==='historial'"></app-historial>
                <app-biblioteca [simulacion]="simulacion" *ngIf="menuMostrar==='biblioteca'"></app-biblioteca>
                <app-resultados-seicep *ngIf="menuMostrar==='resultados-seicep'"></app-resultados-seicep>
                <app-instrumento-autoevaluacion [simulacion]="simulacion" *ngIf="menuMostrar==='instrumento-autoevaluacion'"></app-instrumento-autoevaluacion>
                <app-new-pme [simulacion]="simulacion" *ngIf="menuMostrar==='new-planmejora'"></app-new-pme>
                <app-medicion-satisfaccion [simulacion]="simulacion" *ngIf="menuMostrar==='medicion-satisfaccion'"></app-medicion-satisfaccion>
            </main>

        </div>



        <div>
    </div>